export const itemCache = {
  created() {
    this._itemCaches = {}
  },
  methods: {
    /**
     * Memoize a compute function by item reference, invalidated by `sig`.
     * `cacheName` namespaces caches so multiple methods can coexist on the same component.
     * Backed by a WeakMap so cache entries are GC'd when items are released.
     */
    cachedByItem(cacheName, item, sig, compute) {
      let cache = this._itemCaches[cacheName]
      if (!cache) {
        cache = this._itemCaches[cacheName] = new WeakMap()
      }
      const cached = cache.get(item)
      if (cached && cached.sig === sig) return cached.value
      const value = compute()
      cache.set(item, { sig, value })
      return value
    }
  }
}
